import { connect } from "react-redux";
import {
  Card,
  CardContent,
  CardHeader,
} from "@mui/material";
import React from "react";
import Structure from "./Structure";

const MyStructureSettings = ({GetMyStructure,structures,loggedUser, wholeStructure }) => {
  const [selectedStructure, setSelectedStructure] = React.useState();
  const [select, setSelect] = React.useState(false);
  const [open, setOpen] = React.useState(0);

  return (
    <div className="w-full mb-12 px-4">

      <Card className="flex flex-col w-full">
        <CardHeader
          title={"Structure"}
        />
        <CardContent>
          <Structure
          wholeStructure={wholeStructure}
          structures={structures} onSuccess={()=>{GetMyStructure()}} setSelect={setSelect} 
          setSelectedStructure={setSelectedStructure}
          loggedUser={loggedUser}
          open={open}
          setOpen={setOpen}
          />
        </CardContent>
      </Card>
    </div>
  );
};
export default MyStructureSettings;
